var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChanges(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.3333V14.2859C17.5 15.8078 17.5 16.5688 17.027 17.0542C16.554 17.5396 15.7986 17.5591 14.2877 17.5983C12.8932 17.6344 11.2881 17.6666 10 17.6666C8.71195 17.6666 7.10675 17.6344 5.71226 17.5983C4.20142 17.5591 3.446 17.5396 2.973 17.0542C2.5 16.5688 2.5 15.8078 2.5 14.2859V13.0002L3.33333 15.4166L4.16667 16.6666C4.16667 16.6666 7.37624 17.0833 10 17.0833C12.6238 17.0833 15.8333 16.6666 15.8333 16.6666L16.6667 15.4166L17.5 13.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11V13.5477C3 14.9761 3 15.6903 3.44373 16.1696C3.88747 16.6488 4.58431 16.7025 5.97799 16.8098C7.28099 16.9102 8.78592 17 10 17C11.2141 17 12.719 16.9102 14.022 16.8098C15.4157 16.7025 16.1125 16.6488 16.5563 16.1696C17 15.6903 17 14.9761 17 13.5477V11",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8571 9.64185L9.99996 12.499L7.14282 9.64185",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5L10 2.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChanges);
export default __webpack_public_path__ + "static/media/changes.ffb42050.svg";
export { ForwardRef as ReactComponent };